"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncateMiddle = void 0;
var truncateMiddle = function (fullStr, strLen, charsToShow, separator) {
    var sep = separator || '...';
    var sepLen = sep.length;
    var evenNumberStringLength = fullStr.length % 2 === 0;
    if (strLen && fullStr.length <= strLen)
        return fullStr;
    if (!strLen && charsToShow && fullStr.length <= charsToShow * 2 + sepLen)
        return fullStr;
    var charsCount = 0;
    if (charsToShow)
        charsCount = charsToShow;
    if (strLen)
        charsCount = Math.ceil((strLen - sepLen) / 2);
    return (fullStr.substr(0, charsCount) +
        sep +
        fullStr.substr(fullStr.length - (strLen && evenNumberStringLength ? charsCount - 1 : charsCount)));
};
exports.truncateMiddle = truncateMiddle;
//# sourceMappingURL=truncate-middle.js.map